/**
 * Global auth middleware. On any route that isn't /auth/*, if no token is present,
 * redirect to the auth app (auth.privacybee.com OAuth) preserving the buyer's plan
 * selection via the OAuth `state` param.
 */
import { createOAuthStateNonce } from '~/utils/oauth-state';

export default defineNuxtRouteMiddleware((to) => {
    if (import.meta.server) return;
    if (to.path.startsWith('/auth/')) return;
    if (to.meta.public === true) return;

    const config = useRuntimeConfig();
    const auth = useAuthStore();

    if (auth.token) return;

    // CSRF (RFC 6749 §10.12): carry a random per-login nonce in `state` and store it for this tab;
    // the callback rejects the code exchange unless the returned nonce matches.
    const nonce = createOAuthStateNonce();
    const state = encodeURIComponent(JSON.stringify({
        plan: to.query.plan ?? null,
        term: to.query.term ?? null,
        path: to.fullPath,
        nonce,
    }));

    const redirectUri = encodeURIComponent(config.public.pb.authRedirectUri as string);
    const clientId = config.public.pb.authClientId;
    const responseType = config.public.pb.authResponseType || 'code';

    const authUrl = `${config.public.pb.authApp}?response_type=${responseType}&client_id=${clientId}&redirect_uri=${redirectUri}&state=${state}`;
    return navigateTo(authUrl, { external: true });
});
